import { render, staticRenderFns } from "./resultado-compatibilidad.vue?vue&type=template&id=280bcf80"
import script from "./resultado-compatibilidad.vue?vue&type=script&lang=js"
export * from "./resultado-compatibilidad.vue?vue&type=script&lang=js"
import style0 from "./resultado-compatibilidad.vue?vue&type=style&index=0&id=280bcf80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports